import { isString } from './validate'

const DEVICE_IDENTIFIER_KEY = 'device_identifier'
const CASHIER_NEW_ORDER_BANNER_SEEN_KEY = 'cashier_new_order_banner_version'

export const getCashierNewOrderBannerSeen = () => {
  return localStorage.getItem(CASHIER_NEW_ORDER_BANNER_SEEN_KEY) || ''
}

export const setCashierNewOrderBannerSeen = (version) => {
  localStorage.setItem(CASHIER_NEW_ORDER_BANNER_SEEN_KEY, version)
}

export const getDeviceIdentifier = () => {
  return localStorage.getItem(DEVICE_IDENTIFIER_KEY) || ''
}

export const setDeviceIdentifier = (identifier) => {
  if (!isString(identifier)) {
    return
  }

  localStorage.setItem(DEVICE_IDENTIFIER_KEY, identifier)
}

export const clearStorageKeys = (keys) => {
  keys.forEach((key) => localStorage.removeItem(key))
}
